// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_USERS_REQUEST,
  DELETE_USERS_REQUEST,
  FETCH_USER_REQUEST,
  UPDATE_USERS_REQUEST,
  OPEN_EDIT_PAGE,
  KPI_USERS_REQUEST,
  UPDATE_PWD_REQUEST,
  REQUEST_PASSWORD_RESET,
  VALIDATE_PASSWORD_TOKEN,
  RESET_PASSWORD,
  REGISTER_USER_REQUEST,
  ACTIVATE_ACCOUNT_REQUEST,
  FETCH_CUSTOMERS_REQUEST,
  KPI_CUSTOMERS_REQUEST,
  VERIFY_USER_REQUEST,
  BAN_USER_REQUEST,
  RESEND_ACTIVATION_EMAIL_REQUEST,
  SEND_EMAIL_ADMIN_REQUEST,
  ACTIVATE_USER_REQUEST,
} from './actionTypes';

import {
  UPDATE_PREF_REQUEST
} from '../auth/actionTypes';

import {
  fetchUsersSuccess,
  fetchUsersFailure,
  deleteUserSuccess,
  deleteUserFailure,
  fetchUserSuccess,
  fetchUserFailure,
  updateUserSuccess,
  updateUserFailure,
  openEditPageSuccess,
  fetchUsersKpiSuccess,
  fetchUsersKpiFailure,
  updatePwdSuccess,
  requestPasswordResetSuccess,
  requestPasswordResetFailure,
  validatePasswordTokenSuccess,
  validatePasswordTokenFailure,
  resetPasswordSuccess,
  resetPasswordFailure,
  activateAccountSuccess,
  activateAccountFailure,
  registerUserFailure,
  registerUserSuccess,
  fetchCustomersRequest,
  fetchCustomersFailure,
  fetchCustomersSuccess,
  fetchCustomersKpiSuccess,
  fetchCustomersKpiFailure,
  verifyUserSuccess,
  verifyUserFailure,
  updatePrefSuccess,
  updatePrefFailure,
  resendActivationEmailSuccess,
  resendActivationEmailFailure,
  sendEmailAdminSuccess,
  sendEmailAdminFailure,
  activateUserSuccess,
  activateUserFailure
} from './actions';
import { activateAccount, ActivateUser, deleteUser, getAllCustomers, getAllUsers, getCustomersKPI, getUser, getUsersKPI, registerUser, requestPasswordReset, resendActivationEmail, resetPasswordWithToken, sendEmailAdmin, setUserBan, updateUser, updateUserPassword, updateUserPref, validatePasswordToken, verifyUser } from '../../helpers/backend_helper';
import { fetchGroupsRequest, loginSuccess, loginUser } from '../actions';

import { reduxSerializedError } from '../../utils/utils'; //update token on call API


function* fetchUsersSaga() {
  try {
    const response = yield call(getAllUsers);
    yield put(fetchUsersSuccess(response));
    yield put(fetchGroupsRequest());
    

  } catch (error) {
    yield put(fetchUsersFailure(reduxSerializedError(error)));
  }
}

function* fetchCustomersSaga() {
  try {
    const response = yield call(getAllCustomers);
    yield put(fetchCustomersSuccess(response));

  } catch (error) {
    yield put(fetchCustomersFailure(reduxSerializedError(error)));
  }
}

function* fetchUserSaga({ payload }) {
  try {
    const response = yield call(getUser, payload);
    yield put(fetchUserSuccess(response));
  } catch (error) {
    yield put(fetchUserFailure(reduxSerializedError(error)));
  }
}

function* deleteUsersSaga({ payload }) {
  try {
    yield call(deleteUser, payload);
    yield put(deleteUserSuccess(payload));
    yield call(fetchUsersSaga); // Refresh the user list
  } catch (error) {
    yield put(deleteUserFailure(reduxSerializedError(error)));
  }
}

function* updateUserSaga({ payload }) {
  const { user, navigate, isProfile } = payload;
  try {
    const response = yield call(updateUser, user);
    if(!isProfile) {
      navigate(`/users`);
      yield call(fetchUsersSaga);
    } 
    yield put(updateUserSuccess(response));
  } catch (error) {
    yield put(updateUserFailure(reduxSerializedError(error)));
  }
}

function* openEditPageSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/users/${id}`);
    yield put(openEditPageSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

function* fetchUsersKpiSaga() {
  try {
    const response = yield call(getUsersKPI);
    yield put(fetchUsersKpiSuccess(response));
  } catch (error) {
    yield put(fetchUsersKpiFailure(reduxSerializedError(error)));
  }
}

function* fetchCustomersKpiSaga() {
  try {
    const response = yield call(getCustomersKPI);
    yield put(fetchCustomersKpiSuccess(response));
  } catch (error) {
    yield put(fetchCustomersKpiFailure(reduxSerializedError(error)));
  }
}

function* updatePwdSaga({ payload }) {
  const { user, navigate, isProfile } = payload;
  try {
    yield call(updateUserPassword, user);
    if(!isProfile) {
      navigate(`/users`);
    } else {
      yield put(loginUser(user, navigate, isProfile))
    }
    yield put(updatePwdSuccess());
    yield call(fetchUsersSaga); // Refresh the user list
  } catch (error) {
    yield put(updateUserFailure(reduxSerializedError(error)));
  }
}

function* requestPasswordResetSaga({ payload }) {
  try {
    const response = yield call(requestPasswordReset, payload);
    yield put(requestPasswordResetSuccess(response.data));
  } catch (error) {
    yield put(requestPasswordResetFailure(reduxSerializedError(error)));
  }
}

function* validatePasswordTokenSaga({ payload }) {
  try {
    const response = yield call(validatePasswordToken, payload);
    yield put(validatePasswordTokenSuccess(response.data));
  } catch (error) {
    yield put(validatePasswordTokenFailure(reduxSerializedError(error)));
  }
}

function* resetPasswordSaga({ payload }) {
  const { passwordData, navigate } = payload;
  try {
    yield call(resetPasswordWithToken, passwordData);
    yield put(resetPasswordSuccess());
    // La redirection sera gérée par le composant après avoir affiché le message de succès
  } catch (error) {
    yield put(resetPasswordFailure(reduxSerializedError(error)));
  }
}

function* registerUserSaga({ payload }) {
  const { userData, navigate } = payload;
  try {
    yield call(registerUser, userData);
    
    yield put(registerUserSuccess());
    // Le redirect est géré dans le composant
  } catch (error) {
    yield put(registerUserFailure(reduxSerializedError(error)));
  }
}

function* activateAccountSaga({ payload }) {
  const { token, navigate } = payload;
  try {
    yield call(activateAccount, token);
    
    yield put(activateAccountSuccess());
    // Le redirect est géré dans le composant
  } catch (error) {
    yield put(activateAccountFailure(reduxSerializedError(error)));
  }
}

function* verifyUserSaga({ payload }) {
  try {
    yield call(verifyUser, payload);
    yield put(verifyUserSuccess());
    yield call(fetchUsersSaga); // Refresh the user list
  } catch (error) {
    yield put(verifyUserFailure(reduxSerializedError(error)));
  }
}

function* activateUserSaga({ payload }) {
  try {
    yield call(ActivateUser, payload);
    yield put(activateUserSuccess());
    yield call(fetchUsersSaga); // Refresh the user list
  } catch (error) {
    yield put(activateUserFailure(reduxSerializedError(error)));
  }
}

function* banUserSaga({ payload }) {
  const { user, navigate } = payload;
  try {
    yield call(setUserBan, user);
    yield put(updateUserSuccess());
    yield call(fetchUsersSaga); // Refresh the user list
  } catch (error) {
    yield put(updateUserFailure(reduxSerializedError(error)));
  }
}


function* updatePrefSaga({ payload }) {
  const { userId, prefs } = payload;
  try {
    const response = yield call(updateUserPref, userId, prefs );
    yield put(updatePrefSuccess(response));
  }
  catch (error) {
    yield put(updatePrefFailure(reduxSerializedError(error)));
  }
}

function* resendActivationEmailSaga({ payload }) {
  try {
    yield call(resendActivationEmail, payload);
    yield put(resendActivationEmailSuccess());
  } catch (error) {
    yield put(resendActivationEmailFailure(reduxSerializedError(error)));
  }
}

function* sendEmailAdminSaga({ payload }) {
  try {
    yield call(sendEmailAdmin, payload);
    yield put(sendEmailAdminSuccess());
  } catch (error) {
    yield put(sendEmailAdminFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_USERS_REQUEST, fetchUsersSaga);
  yield takeEvery(FETCH_CUSTOMERS_REQUEST, fetchCustomersSaga);
  yield takeEvery(FETCH_USER_REQUEST, fetchUserSaga);
  yield takeEvery(UPDATE_USERS_REQUEST, updateUserSaga);
  yield takeEvery(DELETE_USERS_REQUEST, deleteUsersSaga);
  yield takeEvery(OPEN_EDIT_PAGE, openEditPageSaga);
  yield takeEvery(KPI_USERS_REQUEST, fetchUsersKpiSaga);
  yield takeEvery(KPI_CUSTOMERS_REQUEST, fetchCustomersKpiSaga);
  yield takeEvery(UPDATE_PWD_REQUEST, updatePwdSaga);
  yield takeEvery(REQUEST_PASSWORD_RESET, requestPasswordResetSaga);
  yield takeEvery(VALIDATE_PASSWORD_TOKEN, validatePasswordTokenSaga);
  yield takeEvery(RESET_PASSWORD, resetPasswordSaga);
  yield takeEvery(REGISTER_USER_REQUEST, registerUserSaga);
  yield takeEvery(ACTIVATE_ACCOUNT_REQUEST, activateAccountSaga);
  yield takeEvery(VERIFY_USER_REQUEST, verifyUserSaga);
  yield takeEvery(ACTIVATE_USER_REQUEST, activateUserSaga);
  yield takeEvery(BAN_USER_REQUEST, banUserSaga);
  yield takeEvery(UPDATE_PREF_REQUEST, updatePrefSaga);
  yield takeEvery(RESEND_ACTIVATION_EMAIL_REQUEST, resendActivationEmailSaga);
  yield takeEvery(SEND_EMAIL_ADMIN_REQUEST, sendEmailAdminSaga);
}
